import Image from "../base/Image";

function Product({
  className = "",
  name,
  number,
  version,
  image = null,
  imageSize = "w-8 h-8",
  bgColor = "bg-gray-300",
  ...rest
}) {
  return (
    <div className={`${className} flex items-center`} {...rest}>
      {image ? <Image className="mr-2" src={image} size={imageSize} /> : null}
      <div>
        <div>
          [{number}
          {version ? ` | v${version}` : ""}] {name}
        </div>
      </div>
    </div>
  );
}

export default Product;
